<template>
	<div>
		<button
			:title="disabled ? disabledTitle : title"
			:disabled="disabled"
			class="jmiBtn orange withIcon"
			@click="triggerFileInput"
		>
			<span class="fa-light fa-upload"></span>
			{{ title }}
		</button>
		<form v-if="!disabled" class="hidden" enctype="multipart/form-data">
			<input
				:id="inputId"
				ref="fileInput"
				style="position: relative; overflow: hidden; opacity: 0"
				type="file"
				:accept="accept"
				:name="inputName"
				@change="handleFileUpload"
			/>
			<input type="hidden" name="tenantId" :value="tenantId" />
			<input v-if="reseller" type="hidden" name="reseller" value="true" />
		</form>
	</div>
</template>

<script>
export default {
	props: {
		disabled: Boolean,
		title: {
			type: String,
			default: 'Import'
		},
		disabledTitle: String,
		accept: {
			type: String,
			default: '.csv'
		},
		inputId: {
			type: String,
			default: 'csvFile'
		},
		inputName: {
			type: String,
			default: 'csvFile'
		},
		tenantId: [String, Number],
		reseller: Boolean
	},
	emits: ['file-selected'],
	methods: {
		triggerFileInput() {
			this.$refs.fileInput.click()
		},
		handleFileUpload(event) {
			if (event?.target?.files?.length) {
				this.$emit('file-selected', event)
				event.target.value = null
			}
		}
	}
}
</script>
